import { useState } from "react";
import { toast } from "sonner";
import { Copy, ExternalLink, X } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const IAB = /FBAN|FBAV|FB_IAB|FBIOS|Instagram|Messenger|WhatsApp|TikTok|musical_ly|Bytedance|Snapchat|LinkedInApp|GSA\/|Line\/|MicroMessenger|Twitter|; wv\)/i;

export const isInAppBrowser = (ua = navigator.userAgent) => IAB.test(ua);
const isAndroid = (ua = navigator.userAgent) => /Android/i.test(ua);

export const chromeIntent = (href = window.location.href) => {
  const u = new URL(href);
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(href)};end`;
};

// Facebook / Instagram / Messenger / WhatsApp / TikTok … webviews cannot download APK files: send the visitor to Chrome.
export const InAppBrowserBanner = () => {
  const { t } = useI18n();
  const [closed, setClosed] = useState(false);
  if (closed || !isInAppBrowser()) return null;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success(t("iab.copied"));
    } catch {
      window.prompt(t("iab.copy"), window.location.href);
    }
  };
  return (
    <div className="sticky top-0 z-50 border-b border-[rgba(245,197,66,0.4)] bg-[#1a1204] px-4 py-3 text-sm text-amber-50" role="alert" data-testid="in-app-browser-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3">
        <p className="min-w-0 flex-1 basis-60 font-semibold">{t(isAndroid() ? "iab.title" : "iab.titleIos")}</p>
        {isAndroid() && (
          <a href={chromeIntent()} className="btn-gold btn-sm" data-testid="in-app-open-chrome"><ExternalLink className="h-4 w-4" /> {t("iab.openChrome")}</a>
        )}
        <button type="button" onClick={copy} className="btn-red btn-sm" data-testid="in-app-copy-link"><Copy className="h-4 w-4" /> {t("iab.copy")}</button>
        <button type="button" onClick={() => setClosed(true)} aria-label={t("iab.close")} className="rounded-full p-1.5 text-amber-200 hover:bg-white/10" data-testid="in-app-banner-close"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
